import Vue from 'vue'
import axios from './http'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

export default {
  Login(params) {
    return Vue.axios.post('/client/login', params)
  },
  Logout(id) {
    return Vue.axios.delete('/client/logout/' + id)
  },
  FetchDashboardBox(params) {
    return Vue.axios.get('/client/dashboard/type/1/index/1', {
      params: params
    })
  },
  FetchDashboardChart1() {
    return Vue.axios.get('/client/analytics/customer/tab/6/type/chart')
  },
  FetchDashboardChart2() {
    return Vue.axios.get('/client/analytics/customer/tab/4/type/chart')
  },
  FetchDashboardChart3() {
    return Vue.axios.get('/client/analytics/trx/tab/1/type/chart')
  },
  FetchDashboardChart4() {
    return Vue.axios.get('/client/analytics/trx/tab/4/type/chart')
  },
  FetchAnalyticsTransactionsTabABox() {
    return Vue.axios.get('/client/analytics/trx/tab/1/type/number')
  },
  FetchAnalyticsTransactionsTabAChart() {
    return Vue.axios.get('/client/analytics/trx/tab/1/type/chart')
  },
  FetchAnalyticsTransactionsTabBChart() {
    return Vue.axios.get('/client/analytics/trx/tab/2/type/chart')
  },
  FetchAnalyticsTransactionsTabCChart() {
    return Vue.axios.get('/client/analytics/trx/tab/3/type/chart')
  },
  FetchAnalyticsOutletsTabAChart() {
    return Vue.axios.get('/client/analytics/outlet/tab/1')
  },
  FetchAnalyticsOutletsTabBChart() {
    return Vue.axios.get('/client/analytics/outlet/tab/2')
  },
  FetchAnalyticsCustomersTabABox() {
    return Vue.axios.get('/client/analytics/customer/tab/1/type/number')
  },
  FetchAnalyticsCustomersTabAChart() {
    return Vue.axios.get('/client/analytics/customer/tab/1/type/chart')
  },
  FetchAnalyticsCustomersTabBChart() {
    return Vue.axios.get('/client/analytics/customer/tab/3/type/chart')
  },
  FetchAnalyticsCustomersTabDChart() {
    return Vue.axios.get('/client/analytics/customer/tab/4/type/chart')
  },
  FetchOutletsTable(params) {
    return Vue.axios.get('/client/outlets', {
      params: params
    })
  },
  FetchOutletById(id) {
    return Vue.axios.get('/client/outlets/' + id)
  },
  SaveNewOutlet(params) {
    return Vue.axios.post('/client/outlets', params)
  },
  UpdateOutlet(id, params) {
    return Vue.axios.put('/client/outlets/' + id, params)
  },
  DeleteOutlet(id) {
    return Vue.axios.delete('/client/outlets/' + id)
  },
  FetchAccountsTable(params) {
    return Vue.axios.get('/client/account', {
      params: params
    })
  },
  FetchAccountById(id) {
    return Vue.axios.get('/client/account/' + id)
  },
  SaveNewAccount(params) {
    return Vue.axios.post('/client/account', params)
  },
  DeleteAccount(id) {
    return Vue.axios.delete('/client/account/' + id)
  },
  UpdateAccount(id, params) {
    return Vue.axios.put('/client/account/' + id, params)
  },
  FetchTrxTable(params) {
    return Vue.axios.get('/client/trx', {
      params: params
    })
  },
  FetchTrxCondition() {
    return Vue.axios.get('/client/trx/condition')
  },
  DownloadTrxTable(params) {
    return Vue.axios({
      method: 'get',
      url: '/client/trx',
      responseType: 'arraybuffer',
      params: params
    })
  },
  FetchTrxById(id) {
    return Vue.axios.get('/client/trx/' + id)
  },
  FetchCustomerTable(params) {
    return Vue.axios.get('/client/customer', {
      params: params
    })
  },
  RefundTrxAmount(id, params) {
    return Vue.axios.post('/client/refund/' + id, params)
  },
  FetchRefundTable(params) {
    return Vue.axios.get('/client/refund', {
      params: params
    })
  },
  DownloadRefundTable(params) {
    return Vue.axios({
      method: 'get',
      url: '/client/refund',
      responseType: 'arraybuffer',
      params: params
    })
  },
  FetchRefundById(id) {
    return Vue.axios.get('/client/refund/' + id)
  },
  FetchQrCode() {
    return Vue.axios.get('/client/settings/qrcode')
  },
  CheckDownloadQrcodeZip(params) {
    return Vue.axios({
      method: 'get',
      url: '/client/settings/qrcode?download=zip',
      params: params
    })
  },
  DownloadQrcodeZip(params) {
    return Vue.axios({
      method: 'get',
      url: '/client/settings/qrcode?download=zip',
      responseType: 'arraybuffer',
      params: params
    })
  },
  DowndloadQrcodePDF(params) {
    return Vue.axios({
      method: 'get',
      url: '/client/settings/qrcode',
      responseType: 'arraybuffer',
      params: params
    })
  },
  DownLoadQrcode(params) {
    return Vue.axios({
      method: 'get',
      url: '/client/getImage',
      params: params
    })
  },
  FetchSettleTable(params) {
    return Vue.axios.get('/client/settlement', {
      params: params
    })
  },
  DownloadSettleTable(params) {
    return Vue.axios({
      method: 'get',
      url: '/client/settlement',
      responseType: 'arraybuffer',
      params: params
    })
  },
  DownloadStatement(id) {
    return Vue.axios({
      method: 'get',
      url: '/client/settlement/' + id,
      responseType: 'arraybuffer'
    })
  },
  FetchInvoiceTable(params) {
    return Vue.axios.get('/client/invoice', {
      params: params
    })
  },
  FetchChannel() {
    return Vue.axios.get('/client/channel')
  },
  UpdateChannel(id, params) {
    return Vue.axios.put('/client/channel/' + id, params)
  },
  DeleteChannel(id) {
    return Vue.axios.delete('/client/channel/' + id)
  },
  ActiveChannel(id) {
    return Vue.axios.post('/client/channel/' + id)
  },
  ShowChannel() {
    return Vue.axios.get('/client/showchannel')
  },
  UpdatePassword(params) {
    return Vue.axios.post('/client/settings/password', params)
  },
  UpdateRefundPassword(params) {
    return Vue.axios.post('/client/settings/refundPassword', params)
  },
  ResetPassword(params) {
    return Vue.axios.post('/client/settings/password/action/resetpassword', params)
  },
  FetchAgreementList() {
    return Vue.axios.get('/client/initchannel')
  },
  PostAgreement(id) {
    return Vue.axios.post('/client/initchannel/' + id)
  },
  PostSign() {
    return Vue.axios.put('/client/user/action/sign')
  },
  showRefundDetail() {
    return Vue.axios.get('/client/refundDetail')
  },
  FetchContract(params) {
    return Vue.axios.get('/client/contract', {
      params: params
    })
  },
  FetchContractFile(params) {
    return Vue.axios({
      method: 'get',
      url: '/client/getFile',
      responseType: 'arraybuffer',
      params: params
    })
  },
  FinishOnboarding() {
    return Vue.axios.put('/client/user/action/finishonboarding')
  },
  FetchCouponList(params) {
    return Vue.axios.get('/client/coupon', {
      params: params
    })
  },
  FetchCouponType() {
    return Vue.axios.get('/client/coupontype')
  },
  FetchCouponById(id) {
    return Vue.axios.get('/client/coupontype/' + id)
  },
  FetchCouponNameById(params) {
    return Vue.axios.get('/client/couponname', {
      params: params
    })
  },
  PublishCoupon(params) {
    return Vue.axios.post('/client/coupon', params)
  },
  agreeCoupon(params) {
    return Vue.axios.put('/client/agreecoupon', params)
  },
  changeLanguage(params) {
    return Vue.axios.post('/client/settings/language', params)
  },
  getMenu() {
    return Vue.axios.get('/client/menu')
  },
  ckeckCouponStatus() {
    return Vue.axios.get('/client/couponstatus')
  },
  changeRemark(trxId, params) {
    return Vue.axios.put('/client/trx/' + trxId, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js